import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-brand-bg">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
